export const DEFAULT_CONNECT_TIMEOUT = 10_000;
export const DEFAULT_MESSAGE_TIMEOUT = 150_000;
export const DEFAULT_UNAUTHORIZED_REDIRECT_URL = '/unauthorized';
